// Dependencies
import { Config as ApiConfig } from './types'
import { WooptimaAPI } from './endpoints'
import _ from 'lodash'

// Config
import {
  REACT_APP_ENV,
  WP_BASE_URL,
  WP_PLUGIN_AUTH_NONCE,
} from '../utils/config'

// WooptimaAPI config
const config: ApiConfig = {
  baseURL: WP_BASE_URL,
  timeout: 10000,
  namespace: 'wp-json/wooptima/v1',
  headers: {
    'Content-Type': 'application/json',
  },
}

// Include nonce if conigured
if ( ! _.isEmpty( WP_PLUGIN_AUTH_NONCE) ) {
  config.headers[
    REACT_APP_ENV === 'production' ? 'X-WP-Nonce' : 'X-Wooptima-Nonce'
  ] = WP_PLUGIN_AUTH_NONCE
}

// Intialize WoooptimaAPI
const Api = new WooptimaAPI(config)
export default Api
